<template>
  <a-row class="moderator-layout">
    <a-col flex="250px" class="moderator-layout__left-side">
      <SideBar :items="sidebarItems" />
    </a-col>
    <a-col flex="auto" class="moderator-layout__right-side">
      <div class="moderator-layout__header">
        <HeaderPartnerAccount />
      </div>
      <div ref="scrollElement" class="moderator-layout__content">
        <slot></slot>
      </div>
    </a-col>
  </a-row>
</template>

<script setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import SideBar from '@/components/sidebar/SideBar';
  import HeaderPartnerAccount from '@/components/header/HeaderPartnerAccount';
  import { debounce } from 'lodash-es';
  import { USER_ROLE_MODERATOR } from '@/api/models/UserRole';
  import { useApi } from '@/api/use-api';

  document.title = 'Цифровой университет. НГУ';

  const emit = defineEmits(['scrolled-to-bottom']);
  const api = useApi();
  const scrollThreshold = 30; // Сдвиг в пикселях от края страницы (зазор), когда должен сработать триггер для скролла
  const scrollElement = ref(null);

  onMounted(async () => {
    await updateRequestCount();
    scrollElement.value?.addEventListener('scroll', handleScroll);
  });

  onBeforeUnmount(() => {
    scrollElement.value?.removeEventListener('scroll', handleScroll);
  });

  const handleScroll = debounce(() => {
    const elementHeight = scrollElement.value?.getBoundingClientRect().height;
    const scrollHeight = scrollElement.value?.scrollHeight;
    const scrollBottom = scrollElement.value?.scrollTop + elementHeight;
    if (scrollBottom + scrollThreshold > scrollHeight) {
      emit('scrolled-to-bottom', scrollBottom);
    }
  }, 70);

  const sidebarItems = ref([
    {
      id: 1,
      text: 'Запросы',
      path: 'moderator-requests',
      hash: '#archive',
      type: 'request',
      count: 0,
    },
    {
      id: 2,
      text: 'Инфо',
      path: 'main',
      type: 'info',
      url: 'https://info.nsu.ru',
    },
    {
      id: 3,
      text: 'Витрина',
      type: 'showcases',
      url: '/showcase',
    },
  ]);

  const updateRequestCount = async () => {
    try {
      const response = await api.request.count(USER_ROLE_MODERATOR);
      sidebarItems.value[0].count = response.count;
      if (response.count === 0) {
        sidebarItems.value[0].hash = '#archive';
      } else {
        sidebarItems.value[0].hash = '#new';
      }
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .moderator-layout {
    min-height: 100vh;
    flex-wrap: nowrap;

    .moderator-layout__right-side {
      overflow: hidden;
      height: 100vh;

      .moderator-layout__header {
        border-bottom: 1px solid $color-bg-secondary-grey;
        background-color: $color-bg-primary-white;
        position: sticky;
        padding: 17px 40px 17px 20px;
        top: 0;
        z-index: 1;
      }

      .moderator-layout__content {
        overflow-y: auto;
        height: 100%;
        padding: 30px 40px 10px 20px;
      }
    }
  }
</style>
